import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  CssBaseline,
  Grid,
  Card,
  CardContent,
  Fab,
  Icon,
  Typography,
  withStyles,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Input,
  CardHeader,
  Select,
  MenuItem,
  ButtonBase,
} from '@material-ui/core';
import moment from 'moment';
import { DatePicker } from 'material-ui-pickers';
import * as Constant from '../../constant';
import * as Helper from '../../helper';
import LocalizedString from '../../localization';
import { PageHeaderUser, LoadingIndicator } from '../../component';
import ReeferDataDetailContainer from './reefer-data-detail.container';

const styles = theme => ({
  backIcon: {
    ...Constant.DEFAULT_STYLES.WEB_USER.BACK_ICON,
  },
  detailButton: {
    backgroundColor: '#ffffff',
  },
  searchButton: {
    ...Constant.DEFAULT_STYLES.WEB_USER.BACK_ICON,
  },
  moreButton: {
    ...Constant.DEFAULT_STYLES.WEB_USER.BUTTON_PRIMARY,
  },
  alignRight: {
    textAlign: 'right',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  cardItem: {
    width: '100%',
    border: '1px solid #E5E5E5',
    borderRadius: '6px',
    boxSizing: 'border-box',
    padding: '16px',
    marginBottom: theme.spacing.unit,
    '&:last-child': {
      marginBottom: 0,
    },
    transition: 'background-color 0.4s',
  },
  cardItemActive: {
    backgroundColor: 'rgba(80, 171, 241, 0.2)',
  },
  cardItemContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    marginTop: theme.spacing.unit * 2,
    maxBlockSize: '500px',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
  },
  contentDrawerOpen: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${Constant.DRAWER_NOTIFICATION_WIDTH}px)`,
    },
  },
  contentDrawerClosed: {
    width: '100%',
  },
  detailHeader: {
    color: '#0066CB',
  },
  itemPerRowContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  pageNavigatorContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  pageTitle: {
    color: '#0266B4',
  },
  root: {
    width: '100%',
  },
  tablePagination: {
    display: 'flex',
    justifyContent: 'space-between',
    flexGrow: 1,
    marginTop: '24px',
  },
  tablePaginationPageInput: {
    flexGrow: 1,
    display: 'inline-block',
    textAlign: 'center',
    verticalAlign: 'baseline',
  },
  tableRow: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
});

const renderBlCard = (
  classes, reeferData, activeBl, onMorePress,
) => {
  if (!reeferData) {
    return (<Typography>No BL available</Typography>);
  }

  return reeferData.map(item => (
    <ButtonBase
      component="div"
      key={item.blNo}
      className={classNames(classes.cardItem, {
        [classes.cardItemActive]: activeBl && item.blNo === activeBl.blNo,
      })}
      onClick={() => onMorePress(item.blNo)}
    >
      <Grid container spacing={24}>
        <Grid item xs={12} md={12}>
          <Typography color="primary" variant="h6">
            BL No.
            &nbsp;
            {item.blNo}
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography variant="caption">Date</Typography>
          <Typography>
            {Helper.toMoment(item.shiftDate).format(Constant.MOMENT_DATE_FORMAT_STRING)}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4} className={classes.alignRight}>
          <Typography variant="caption">Party</Typography>
          <Typography>
            {`1 - ${item.total}`}
          </Typography>
        </Grid>
      </Grid>
    </ButtonBase>
  ));
};

const renderBlDetail = (
  classes, activeBl, containerTracking,
  filters, sortField, sortDirection,
  pageSize, activePage, totalPage,
  onChangeFilter, onChangePaging, handleChangeSort,
  onDetailPress,
) => {
  if (!activeBl) {
    return (<></>);
  }

  return (
    <Card>
      <CardHeader
        title={(
          <>
            <Typography variant="h6" className={classes.detailHeader}>
              BL No.&nbsp;
              {activeBl.blNo}
            </Typography>
            <div className={classes.itemPerRowContainer}>
              <Select
                value={pageSize}
                onChange={event => onChangePaging(
                  Constant.RXTABLEFIELD_PAGE_SIZE,
                  event.target.value,
                )}
              >
                {Constant.DEFAULT_PAGE_SIZE_OPTIONS.map(item => (
                  <MenuItem value={item} key={item}>
                    {item}
                    &nbsp;
                    {LocalizedString.common.labelRows}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </>
        )}
      />
      <CardContent>
        <div style={{ width: '100%', overflow: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={
                      Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_CONTAINER_NUMBER)
                    }
                    IconComponent={Helper.getSortIcon(
                      Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_CONTAINER_NUMBER),
                      sortDirection,
                    )}
                    onClick={() => handleChangeSort(Constant.TABLE_FIELD_CONTAINER_NUMBER)}
                  >
                    {LocalizedString.reeferData.lblContainerNumber}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_SHIFT_DATE)}
                    IconComponent={Helper.getSortIcon(
                      Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_SHIFT_DATE),
                      sortDirection,
                    )}
                    onClick={() => handleChangeSort(Constant.TABLE_FIELD_SHIFT_DATE)}
                  >
                    {LocalizedString.reeferData.lblContainerShiftDate}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_SIZE)}
                    IconComponent={Helper.getSortIcon(
                      Helper.isSortFieldActive(sortField, Constant.TABLE_FIELD_SIZE),
                      sortDirection,
                    )}
                    onClick={() => handleChangeSort(Constant.TABLE_FIELD_SIZE)}
                  >
                    {LocalizedString.reeferData.lblContainerSize}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  {LocalizedString.reeferData.lblContainerParty}
                </TableCell>
                <TableCell>
                  Action(s)
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <Input
                    type="text"
                    value={filters[Constant.TABLE_FIELD_CONTAINER_NUMBER]}
                    onChange={
                      ({ nativeEvent }) => onChangeFilter(
                        Constant.TABLE_FIELD_CONTAINER_NUMBER,
                        nativeEvent.target.value,
                      )
                    }
                    fullWidth
                    placeholder={LocalizedString.common.placeholderSearch}
                  />
                </TableCell>
                <TableCell>
                  {/* <Input
                    type="date"
                    value={filters[Constant.TABLE_FIELD_GATE_IN_CDP]}
                    onChange={
                      ({ nativeEvent }) => onChangeFilter(
                        Constant.TABLE_FIELD_GATE_IN_CDP,
                        nativeEvent.target.value,
                      )
                    }
                    fullWidth
                  /> */}
                  <DatePicker
                    value={filters[Constant.TABLE_FIELD_GATE_IN_CDP] || null}
                    clearable
                    emptyLabel="DD MMM YYYY"
                    format="DD MMM YYYY"
                    onChange={value => onChangeFilter(
                      Constant.TABLE_FIELD_GATE_IN_CDP,
                      value,
                    )}
                  />
                </TableCell>
                <TableCell>
                  <Input
                    type="number"
                    value={filters[Constant.TABLE_FIELD_SIZE]}
                    onChange={
                      ({ nativeEvent }) => onChangeFilter(
                        Constant.TABLE_FIELD_SIZE,
                        nativeEvent.target.value,
                      )
                    }
                    fullWidth
                    placeholder={LocalizedString.common.placeholderSearch}
                  />
                </TableCell>
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {containerTracking && containerTracking.map(container => (
                <TableRow key={container.containerNo} className={classes.tableRow}>
                  <TableCell>
                    <Typography>{container.containerNo}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {moment(container.gateInCdp)
                        .format(Constant.MOMENT_DATE_TIME_SEPARATED_FORMAT_STRING)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{container.ctrSize}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>
                      {container.party}
                      &nbsp;of&nbsp;
                      {activeBl.total}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      color="primary"
                      classes={{ outlinedPrimary: classes.detailButton }}
                      onClick={() => onDetailPress(activeBl.blNo, container.containerNo)}
                    >
                      Detail
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <div className={classes.tablePagination}>
          <Button
            variant="contained"
            style={{ flexGrow: 1 }}
            disabled={!activePage || activePage === 1}
            onClick={() => onChangePaging(Constant.RXTABLEFIELD_ACTIVE_PAGE, activePage - 1)}
          >
            {LocalizedString.common.labelPagingPrevButton}
          </Button>

          <div className={classes.tablePaginationPageInput}>
            <span style={{ fontWeight: 500 }}>{LocalizedString.common.labelPagingPage}</span>
            <Input
              type="number"
              value={activePage}
              style={{ width: '50%' }}
              inputProps={{
                min: 1,
                max: totalPage,
                step: 1,
                style: { textAlign: 'center' },
              }}
              onChange={({ nativeEvent }) => onChangePaging(
                Constant.RXTABLEFIELD_ACTIVE_PAGE,
                parseInt(nativeEvent.target.value, 10),
              )}
            />
            <span style={{ fontWeight: 500 }}>
              {`${LocalizedString.common.labelPagingPageOf} ${totalPage}`}
            </span>
          </div>

          <Button
            variant="contained"
            style={{ flexGrow: 1 }}
            disabled={activePage && activePage === totalPage}
            onClick={() => onChangePaging(Constant.RXTABLEFIELD_ACTIVE_PAGE, activePage + 1)}
          >
            {LocalizedString.common.labelPagingNextButton}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

class ReeferDataBase extends Component {
  componentDidMount() {
    this.props.onAppear();
  }

  handleChangeSort = (newSortField) => {
    const { sortField, sortDirection, onChangeSort } = this.props;
    if (newSortField === sortField) {
      onChangeSort(
        sortField,
        sortDirection === Constant.TABLE_SORT_ASCENDING
          ? Constant.TABLE_SORT_DESCENDING
          : Constant.TABLE_SORT_ASCENDING,
      );
    } else {
      onChangeSort(newSortField, Constant.TABLE_SORT_ASCENDING);
    }
  };

  render() {
    const {
      classes,
      notificationOpen,
      downloadingReeferData,
      searchBarText,
      reeferData,
      activeBl,
      containerTracking,
      activePage,
      totalPage,
      filters,
      sortField,
      sortDirection,
      pageSize,
      onChangeSearchBarText,
      onMorePress,
      onChangeFilter,
      onChangePaging,
      onDetailPress,
      dialogReeferDataDetailStatus,
    } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />

        <PageHeaderUser />

        <div
          className={
            classNames(classes.content, {
              [classes.contentDrawerOpen]: notificationOpen,
              [classes.contentDrawerClosed]: !notificationOpen,
            })
          }
          style={{ padding: '16px' }}
        >
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <div className={classes.pageNavigatorContainer}>
                    <Fab
                      variant="round"
                      classes={{ root: classes.backIcon }}
                      component={Link}
                      to={Constant.ROUTE_NAME_DASHBOARD_USER}
                    >
                      <Icon>chevron_left</Icon>
                    </Fab>
                    <div style={{ marginLeft: '32px' }}>
                      <Typography variant="h5" className={classes.pageTitle}>{LocalizedString.reeferData.title}</Typography>
                      <Typography variant="caption">{LocalizedString.reeferData.caption}</Typography>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card>
                <CardContent>
                  <div style={{ display: 'flex' }}>
                    <div style={{ flexGrow: 1, alignSelf: 'flex-end' }}>
                      <TextField
                        fullWidth
                        placeholder="Search BL no"
                        value={searchBarText}
                        onChange={event => onChangeSearchBarText(event.target.value)}
                      />
                    </div>
                    <div style={{ display: 'inline-flex', marginLeft: '8px' }}>
                      <Fab
                        size="small"
                        variant="round"
                        color="default"
                        className={classes.searchButton}
                      >
                        <Icon>search</Icon>
                      </Fab>
                    </div>
                  </div>

                  <div className={classes.cardItemContainer}>
                    {renderBlCard(classes, reeferData, activeBl, onMorePress)}
                  </div>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={8}>
              {renderBlDetail(
                classes, activeBl, containerTracking,
                filters, sortField, sortDirection,
                pageSize, activePage, totalPage,
                onChangeFilter, onChangePaging, this.handleChangeSort,
                onDetailPress,
              )}

              <ReeferDataDetailContainer
                open={dialogReeferDataDetailStatus}
              />
            </Grid>
          </Grid>
        </div>

        {downloadingReeferData && <LoadingIndicator />}
      </div>
    );
  }
}
ReeferDataBase.propTypes = {
  classes: PropTypes.shape(PropTypes.any).isRequired,
  notificationOpen: PropTypes.bool,
  downloadingReeferData: PropTypes.bool,
  searchBarText: PropTypes.string.isRequired,
  reeferData: PropTypes.arrayOf(PropTypes.any),
  containerTracking: PropTypes.arrayOf(PropTypes.any),
  activeBl: PropTypes.shape({
    id: PropTypes.string,
    containers: PropTypes.arrayOf(PropTypes.any),
  }),
  filters: PropTypes.shape(PropTypes.any).isRequired,
  sortField: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  activePage: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onChangeSearchBarText: PropTypes.func.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  onChangePaging: PropTypes.func.isRequired,
  onChangeSort: PropTypes.func.isRequired,
  onMorePress: PropTypes.func.isRequired,
  onDetailPress: PropTypes.func.isRequired,
  onAppear: PropTypes.func.isRequired,
  dialogReeferDataDetailStatus: PropTypes.bool.isRequired,
};
ReeferDataBase.defaultProps = {
  notificationOpen: false,
  downloadingReeferData: true,
  reeferData: [],
  activeBl: undefined,
  containerTracking: [],
};

export default withStyles(styles)(ReeferDataBase);
